<script>
  import { Swiper, SwiperSlide } from 'swiper/svelte'
  import { link } from 'svelte-spa-router'
  import 'swiper/css/pagination'
  import 'swiper/css/navigation'
  import 'swiper/css'
  import ProjectCard from '../../components/project-card/ProjectCard.svelte'
  import { PROJECT_STATUSES, sliderOptions, PROJECT_TAGS } from '../../constants/constants'
  import { fetchProjects } from '../../../services/projectDetailService'
  import {projectType, isLoaderActive} from '../../store'
  import { onMount } from 'svelte'
  import './projectListing.css'
  import {updateProject} from "../../../services/strapiRestService";
  import dayjs from "dayjs";

  let completedProjects = []
  let liveProjects = []
  let upcomingProjects = []
  let featuredProjects = []

  const fetchProject = async(projectStatus) => {
    const resultObj = await fetchProjects(projectStatus)
    const { data } = resultObj
    return data
  }

  const fetchCompletedProjects = async () => {
    completedProjects = await fetchProject(PROJECT_STATUSES.COMPLETED)
  }

  const fetchLiveProjects = async () => {
    liveProjects = await fetchProject(PROJECT_STATUSES.LIVE)
  }

  const fetchUpcomingProjects = async () => {
    upcomingProjects = await fetchProject(PROJECT_STATUSES.UPCOMING)
  }

  const fetchFeaturedProjects = async () => {
    let projectData = await fetchProject(null)
    featuredProjects = [...projectData]
  }

  const completedProjectCallback = (project, timestamp, index) => {
    updateProject(project.id, {
      project_end_time: dayjs.unix(timestamp).$d.toISOString()
    });
    liveProjects.splice(index, 1);
    completedProjects.push(project);
    liveProjects = liveProjects;
  }

  let fetchAllProducts = async () => {
    await Promise.allSettled([
      fetchCompletedProjects(),
      fetchLiveProjects(),
      fetchUpcomingProjects(),
      fetchFeaturedProjects()
    ])
  }
  let loaderGif = "./images/loader.gif";

  onMount(() => {
    window.scrollTo(0, 0);
  });

</script>

<div class="container">
  {#await fetchAllProducts()}
    <div class="listing-loader loader flex items-center flex-text-center">
      <img src={loaderGif} alt="Loading..." />
    </div>
  {:then projects}
    {#if featuredProjects.length > 0}
      <div class="on-going-wrapper flex column-direction">
        <div class="flex justify-between items-center slider-header-wrapper">
          <h2 class="slider-title">Featured Projects</h2>
          <a
                  href={`/explore-projects/${PROJECT_TAGS.FEATURED}`}
                  use:link
                  class="see-all"
                  on:click={() => projectType.set(PROJECT_STATUSES.LIVE)}>
            View All
          </a>
        </div>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
          {#each featuredProjects as project,index}
            <SwiperSlide>
              <ProjectCard {project} />
            </SwiperSlide>
          {/each}
        </Swiper>
      </div>
    {/if}
    {#if liveProjects.length > 0}
      <div class="on-going-wrapper flex column-direction">
        <div class="flex justify-between items-center slider-header-wrapper">
          <h2 class="slider-title">Live Sales</h2>
          <a
                  href="{`/explore-projects/Live`}"
                  use:link
                  class="see-all"
                  on:click={() => projectType.set(PROJECT_STATUSES.LIVE)}>
            View All
          </a>
        </div>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
          {#each liveProjects as project,index}
            <SwiperSlide>
              <ProjectCard on:completedProject={(event)  => completedProjectCallback(event.detail.project,event.detail.timestamp,index)} {project} />
            </SwiperSlide>
          {/each}
        </Swiper>
      </div>
    {/if}
    {#if upcomingProjects.length > 0}
      <div class="on-going-wrapper flex column-direction">
        <div class="flex justify-between items-center slider-header-wrapper">
          <h2 class="slider-title">Upcoming Sales</h2>
          <a
                  href={`/explore-projects/${PROJECT_STATUSES.UPCOMING}`}
                  use:link
                  class="see-all"
                  on:click={() => projectType.set(PROJECT_STATUSES.UPCOMING)}>
            View All
          </a>
        </div>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
          {#each upcomingProjects as project}
            <SwiperSlide>
              <ProjectCard {project} />
            </SwiperSlide>
          {/each}
        </Swiper>
      </div>
    {/if}
    {#if completedProjects.length > 0}
      <div class="on-going-wrapper flex column-direction">
        <div class="flex justify-between items-center slider-header-wrapper">
          <h2 class="slider-title">Completed Sales</h2>
          <a
                  href={`/explore-projects/${PROJECT_STATUSES.COMPLETED}`}
                  use:link
                  class="see-all"
                  on:click={() => projectType.set(PROJECT_STATUSES.COMPLETED)}>
            View All
          </a>
        </div>
        <Swiper
                slidesPerView={sliderOptions.slidesPerView}
                spaceBetween={sliderOptions.spaceBetween}
                slidesPerGroup={sliderOptions.slidesPerGroup}
                loop={sliderOptions.loop}
                pagination={sliderOptions.pagination}
                navigation={sliderOptions.navigation}
                modules={sliderOptions.modules}
                breakpoints={sliderOptions.breakPoint}
                class="mySwiper">
          {#each completedProjects as project}
            <SwiperSlide>
              <ProjectCard {project} />
            </SwiperSlide>
          {/each}
        </Swiper>
      </div>
    {/if}
    {#if !$isLoaderActive && liveProjects.length === 0 && upcomingProjects.length === 0 && completedProjects.length === 0}
      <div class="no-project-wrapper relative">
        <img src="/images/no_project.svg" alt="no-project" />
        <div class="no-project-content flex column-direction items-center">
          <h2>No project to show</h2>
          <a href="/" class="btn-gradient-background btn-return-home">
            Return to Home
          </a>
        </div>
      </div>
    {/if}
  {:catch error}
    <div class="no-project-wrapper relative">
      <img src="/images/no_project.svg" alt="no-project" />
      <div class="no-project-content flex column-direction items-center">
        <h2>No project to show</h2>
        <a href="/" class="btn-gradient-background btn-return-home">
          Return to Home
        </a>
      </div>
    </div>
  {/await}

</div>
